import React from 'react'
import cimg from '../../images/hb.jpg'
import cimg2 from '../../images/abo.png'


const Appointment = () => {


    return (
        <section className="wpo-contact-section section-padding">
            <div className="wpo-contact-img">
                <img src={cimg} alt="" />
            </div>
            <div className="wpo-contact-img-s2">
                <img src={cimg2} alt="" />
            </div>
            <div className="container">
                <div className="wpo-contact-section-wrapper">
                    <div className="row align-items-center">
                        <div className="col-lg-6 col-md-12 col-12">
                            <div className="wpo-contact-form-area">
                                <div className="wpo-section-title-s2">
                                    <h2>About</h2>
                                    <p style={{color: 'white', marginTop: '20px'}}>Jagruti Chemicals is a trusted supplier of high-quality industrial chemicals across India. We deliver reliable products with expertise, transparency, and timely service to diverse industries.</p>
                                    <p style={{color: 'white', marginTop: '20px'}}>Our product portfolio caters to multiple sectors, including pharmaceuticals, water treatment, food processing, textiles, and manufacturing. Each chemical we supply undergoes strict quality checks to maintain purity, stability, and performance. With transparent communication, prompt delivery, and tailored solutions, we help businesses maintain smooth and efficient production processes.</p>
                                    
                                </div>
                                <div className="border-style"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Appointment;